














































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { auth } from "@/config/host.config";
import { IRoom } from "@/@types/hotel/room";
import { IVirtualRooma } from "@/@types/hotel/virtual_rooms";
import { ILocale } from "@/@types/locale";
import { IRoomServiceRequest } from "@/@types/room-service/room-service";

interface IRoomLevelItem {
  _id: string;
  name: ILocale;
}
interface IRoomLevelMap {
  [levelId: string]: Array<Array<string>>;
}

@Component({})
class RoomPlanModal extends Vue {
  @Prop({ type: Boolean, default: false }) show!: boolean;
  @Prop({ type: Array, default: () => [] })
  requests!: IRoomServiceRequest[];

  loading = false;
  cellSize = 48;
  waif: Array<IRoom> = [];
  rooms: Array<IRoom> = [];
  levels: Array<IRoomLevelItem> = [];
  virtualRooms: Array<IVirtualRooma> = [];

  @Watch("show")
  onShow(val: boolean): void {
    if (val) {
      this.waif = [];
      this.load();
    }
  }

  get cellWidthPx(): string {
    return `${this.cellSize}px`;
  }

  get activeRequests(): IRoomServiceRequest[] {
    return this.requests.filter((r) =>
      ["CREATED", "ASSIGNED", "IN_PROGRESS", "ESCALATED"].includes(r.status)
    );
  }

  get roomList(): IRoomLevelMap {
    const levels: IRoomLevelMap = {};
    this.waif = [];
    const levelsId = this.levels.map((l) => l._id);

    const maximus: { [level: string]: { x: number; y: number } } = {};
    let maxx = 0;
    this.rooms.forEach((el) => {
      if (
        el.level &&
        el.position &&
        el.position.x != null &&
        el.position.x !== undefined &&
        el.position.y != null &&
        el.position.y !== undefined &&
        levelsId.includes(el.level)
      ) {
        const x = parseInt(el.position.x) || 0;
        const y = parseInt(el.position.y) || 0;
        const prev = maximus[el.level] || { x: 0, y: 0 };
        maximus[el.level] = { x: Math.max(prev.x, x), y: Math.max(prev.y, y) };
        maxx = Math.max(maxx, x);
      }
    });
    void maxx;

    if (!Object.keys(maximus).length) {
      this.rooms.forEach((el) => this.waif.push(el));
      return levels;
    }

    this.levels.forEach((lv) => {
      if (!maximus[lv._id]) return;
      const yLen = maximus[lv._id].y + 1;
      const xLen = maximus[lv._id].x + 1;
      const grid: Array<Array<string>> = [];
      for (let i = 0; i < yLen; i++) {
        grid.push(new Array(xLen).fill("*"));
      }
      levels[lv._id] = grid;
    });

    this.rooms.forEach((el) => {
      if (
        !el.level ||
        !el.position ||
        el.position.x == null ||
        el.position.x === undefined ||
        el.position.y == null ||
        el.position.y === undefined ||
        !levelsId.includes(el.level) ||
        !maximus[el.level]
      ) {
        this.waif.push(el);
        return;
      }
      const x = parseInt(el.position.x) || 0;
      const y = parseInt(el.position.y) || 0;
      if (levels[el.level] && levels[el.level][y]) {
        levels[el.level][y][x] = el._id;
      }
    });

    return levels;
  }

  getRoom(id: string): IRoom | undefined {
    if (id === "*") return undefined;
    return this.rooms.find((r) => r._id === id);
  }

  roomName(id: string): string {
    const r = this.getRoom(id);
    return r && r.name ? r.name : "";
  }

  requestsForRoom(id: string): IRoomServiceRequest[] {
    const room = this.getRoom(id);
    if (!room) return [];
    return this.activeRequests.filter(
      (r) => String(r.room_number) === String(room.name)
    );
  }

  countFor(id: string): number {
    return this.requestsForRoom(id).length;
  }

  hasEmergencyFor(id: string): boolean {
    return this.requestsForRoom(id).some(
      (r) =>
        r.serviceType === "EMERGENCY_ASSISTANCE" ||
        r.priority === "CRITICAL" ||
        r.status === "ESCALATED"
    );
  }

  getLevelName(levelId: string): string {
    const lv = this.levels.find((l) => l._id === levelId);
    if (!lv || !lv.name)
      return String(this.$t("roomService.plan.defaultLevel"));
    return lv.name[this.$i18n.locale] || lv.name.ru || lv.name.en || levelId;
  }

  cellClass(id: string): Record<string, boolean> {
    if (id === "*") return { "rs-cell--empty": true };
    const count = this.countFor(id);
    return {
      "rs-cell--idle": count === 0,
      "rs-cell--active": count > 0 && !this.hasEmergencyFor(id),
      "rs-cell--emergency": count > 0 && this.hasEmergencyFor(id),
    };
  }

  cellTitle(id: string): string {
    if (id === "*") return "";
    const name = this.roomName(id);
    const count = this.countFor(id);
    if (count === 0) return `${name}`;
    return `${name} — ${count}`;
  }

  onPick(id: string): void {
    if (id === "*") return;
    const reqs = this.requestsForRoom(id);
    if (!reqs.length) return;
    const room = this.getRoom(id);
    this.$emit("select-room", {
      roomName: room?.name || "",
      requests: reqs,
    });
  }

  close(): void {
    this.$emit("close");
  }

  async load(): Promise<void> {
    this.loading = true;
    const params = {
      "match[show]": true,
      "match[deleted][value]": false,
    };
    try {
      const [roomsRes, levelsRes, vroomsRes] = await Promise.all([
        this.$axios.get(auth.room, { params }),
        this.$axios.get(auth.room_level, { params }),
        this.$axios.get(auth.virtual_rooms, { params }),
      ]);
      if (roomsRes.status === 200) this.rooms = roomsRes.data;
      if (levelsRes.status === 200) this.levels = levelsRes.data;
      if (vroomsRes.status === 200) this.virtualRooms = vroomsRes.data;
    } catch (e) {
      console.log(e);
    } finally {
      this.loading = false;
    }
  }
}
export default RoomPlanModal;
